import React from 'react'
import styled from '@emotion/styled'
import { StorageUtils } from '../../utils/siteUtils'
import TwoButtonModal from '../generic/modals/TwoButtonModal'
import { ModalContentNormal } from '../generic/Basics'
import Error from '../generic/Error'
import VinEntry from '../generic/VinEntry'

export default ({ setShowModal, navigateToNewOfferWithVin, plateStateVinError, vinActiveDealer, updateGlobalState, submitVinNoForm, urlState, offer, globalState, vinModalInfo, isAdmin, plateStateVinErrorMessage }) => {
  const { vinModal, misMatch } = vinModalInfo
  const trimMismatchOverride = offer && offer.prospect.vehicle.vin && offer.prospect.vehicle.vin === urlState.vin && !plateStateVinError
  const vin = globalState.vin || urlState.vin || (offer && offer.prospect.vehicle.vin)
  const onChangeVin = vin => {
    if (vin) {
      updateGlobalState({ vin })
    }
  }

  const decodeVin = barcodeVin => {
    barcodeVin = typeof barcodeVin === 'string' ? barcodeVin : null
    StorageUtils.clearProspect()
    submitVinNoForm(barcodeVin || globalState.vin || urlState.vin, true)
  }
  const isVinActiveDealer = !!vinActiveDealer && !!vinActiveDealer.totalResultCount && vinActiveDealer.totalResultCount > 0 && !vinActiveDealer.privateSeller

  return (
    <TwoButtonModal
      name={'VINModal'} //
      onClickNegative={decodeVin}
      negativeCopyOverride={misMatch ? 'Try Again' : 'Save'}
      onClickPositive={misMatch && (() => decodeVin && navigateToNewOfferWithVin() && setTimeout(setShowModal))}
      positiveCopyOverride={'New Offer'}
      title={'Please Enter VIN'}
      maxWidth={425}
      minHeight={240}
      open={!trimMismatchOverride && vinModal}>
      <StyledModalContent>
        <VinEntry onChange={onChangeVin} error={plateStateVinError} vin={vin} onScanSuccess={decodeVin} setError={() => false} isAdmin={isAdmin} updateGlobalState={updateGlobalState} />
        {misMatch && <Error isError={true} text={"VIN does not match consumer's vehicle. Please double check the VIN or start a new offer."} id={'mismatch-error'} />}
        {plateStateVinError && !isVinActiveDealer && (
          <Error text={vin && vin.length === 17 ? (plateStateVinErrorMessage ? plateStateVinErrorMessage : 'VIN could not be decoded.') : 'A VIN must contain 17 characters.'} id={'vin-error'} testId={'bi-lb-vin-error'} isError={true} />
        )}
      </StyledModalContent>
    </TwoButtonModal>
  )
}

const StyledModalContent = styled(ModalContentNormal)`
  padding: 24px;
`
